export const version = "/api/v1";
